import './App.css';
import Home from './pages/Home/Home';
import Retailer from './pages/Retailers/Retail';
import Manufacturer from './pages/CPG/CPG';
import Team from './pages/Team/Team';
import Contact from './pages/Contact/Contact';
import Rx from './pages/Rx/Rx';
import AppLinkPage from './pages/AppLinks/AppLinkPage';
import NavigationBar from './components/navigationbar/NavigationBar';
import Footer from './components/footer/Footer';
import StructuredData from './components/SEO/StructuredData';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import SubscriptionLayout from './components/layouts/SubscriptionLayout';
import Login from './pages/Subscription/Login';
import Pricing from './pages/Subscription/Pricing';
import Billing from './pages/Subscription/Billing';
import CheckoutSuccess from './pages/Subscription/CheckoutSuccess';
import BetaSignup from './pages/BetaSignup/BetaSignup';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { brand } from './config/brand';

/**
 * The main application component.
 * It sets up the routing and wraps the application with necessary providers.
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <HelmetProvider>
        <AuthProvider>
          <NavigationBar/>
          <StructuredData />
          <GoogleAnalytics />
          <Routes>
            {/* Subscription / Web Portal Routes */}
            <Route element={<SubscriptionLayout />}>
              <Route path='/login' element={<Login />} />
              <Route path='/pricing' element={<Pricing />} />
              <Route path='/billing' element={<Billing />} />
              <Route path='/checkout/success' element={<CheckoutSuccess />} />
              <Route path='/checkout/cancel' element={<Navigate to='/pricing' replace />} />
            </Route>

            {/* Public Routes */}
            <Route path='/' element={<Home />} />
            <Route path='/home' element={<Home />} />
            <Route path='/retailers' element={<Retailer />} />
            <Route path='/brands' element={<Manufacturer />} />
            <Route path='/rx' element={<Rx />} />
            <Route path='/about-us' element={<Team />} />
            <Route path='/book-a-demo' element={<Contact />} />
            <Route path='/beta' element={<BetaSignup />} />
            <Route
              path='/app/download'
              element={
                <AppLinkPage
                  title='Download KAYLUS'
                  description='Use this page to get the KAYLUS mobile app or continue to the website if you are browsing on desktop.'
                  primaryAction={{ label: 'Visit KAYLUS', to: '/' }}
                  secondaryAction={{ label: brand.ctaLabel, to: brand.bookDemoPath }}
                />
              }
            />
            <Route
              path='/app/login'
              element={
                <AppLinkPage
                  title='Open Login in KAYLUS'
                />
              }
            />
            <Route
              path='/app/plaid-auth'
              element={
                <AppLinkPage
                  title='Bank Connection Successful'
                />
              }
            />
            <Route
              path='/app/plaid-settings'
              element={
                <AppLinkPage
                  title='Bank Settings'
                />
              }
            />
            <Route
              path='/app/signup'
              element={
                <AppLinkPage
                  title='Open Sign Up in KAYLUS'
                />
              }
            />
            <Route
              path='/app/brands/:brandId'
              element={
                <AppLinkPage
                  title='Open Brand in KAYLUS'
                  detailValueKey='brandId'
                  detailLabel='Brand ID'
                />
              }
            />
            <Route
              path='/app/offers/:offerId'
              element={
                <AppLinkPage
                  title='Open Offer in KAYLUS'
                  detailValueKey='offerId'
                  detailLabel='Offer ID'
                />
              }
            />
            <Route
              path='/app/wallet'
              element={
                <AppLinkPage
                  title='Open Wallet in KAYLUS'
                />
              }
            />
            <Route
              path='/app/redemption-history'
              element={
                <AppLinkPage
                  title='Open Redemption History in KAYLUS'
                />
              }
            />
            <Route
              path='/app/pharmacy'
              element={
                <AppLinkPage
                  title='Open Pharmacy in KAYLUS'
                />
              }
            />
            <Route
              path='/app/plaid-auth'
              element={
                <AppLinkPage
                  title='Open Plaid Auth in KAYLUS'
                  description='Open this link on your phone to continue your Plaid authentication inside the KAYLUS app.'
                />
              }
            />
            <Route
              path='/app/profile'
              element={
                <AppLinkPage
                  title='Open Profile in KAYLUS'
                  description='Open this link on your phone to view your profile inside the KAYLUS app.'
                />
              }
            />
          </Routes>
          <Footer />
        </AuthProvider>
      </HelmetProvider>
    </Router>
  );
}

export default App;
